import type { ChainType } from "@okcontract/multichain";

import {
  type CacheQuery,
  type DataCacheType,
  SearchQuery,
  TokenByChainPrefixQuery
} from "./coredata";
import { IndexPrefixQuery, prefixFromType } from "./prefix";
import {
  type ABIValue,
  ABIValueTypes,
  ALL_CHAINS,
  TokenCurrentChain
} from "./types";

export type SearchType =
  | DataCacheType // one type
  | typeof ALL_CHAINS // all types (full text search)
  | typeof TokenCurrentChain; // prefix for token on current chains

/**
 * coredata_search_query returns the coredata query.
 * @param ty
 * @param input
 * @returns
 */
export const coredata_search_query = (
  ty: SearchType,
  input: string,
  ch: ChainType
) => {
  // for orgs and abix, we want to search using prefix with partial words
  switch (ty) {
    case "org":
    case "abix":
      return IndexPrefixQuery(ty, input);
    case TokenCurrentChain:
      // @todo support nft, stake, etc.
      return TokenByChainPrefixQuery(ch, `tok:${input}`);
    case "nft":
    case "stake":
    case "lend":
    case "swap":
      return SearchQuery(input, "token");
  }
  // otherwise we do a full-text search (possibly restricted by type)
  return SearchQuery(input, ty !== ALL_CHAINS ? ty : undefined);
};

export const coredata_search_type = (q: CacheQuery): SearchType => {
  if (!q || typeof q !== "string") {
    return;
  }
  switch (q.substring(0, q.indexOf(":"))) {
    case "org":
      return "org";
    case "con":
      return "contract";
    case "stake":
      return "stake";
    case "tok":
      return "token";
    case "nft":
      return "nft";
    case "wid":
      return "widget";
    case "addr":
      return "address";
    case "abix":
      return "abix";
  }
};

/**
 * add_prefix_from_search_type add a search prefix to a string
 * @param ty
 * @param value
 * @returns
 */
export const add_prefix_from_search_type = <T extends SearchType>(
  ty: T,
  str: string
): CacheQuery => {
  // @ts-expect-error @todo
  const pre = prefixFromType(ty);
  return (pre && !str.includes(":") ? `${pre}${str}` : str) as CacheQuery;
};

// @unused
export const get_search_prefix = (a: ABIValue): SearchType =>
  // @ts-expect-error redesign type to exclude string
  ABIValueTypes.includes(a?.ty) ? a.ty : undefined;
